import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { debug } from "@common/lib/log";
import * as React from "react";

export type FacebookComponentProps = RootContainerProps & {
  colorScheme: string;
  embedType: string;
  includeParent: boolean;
  orderBy: string;
  numberOfPosts: number;
  url: string;
};

export default class Facebook extends React.Component<FacebookComponentProps> {
  public componentDidMount() {
    if (document.getElementById("facebook-jssdk")) {
      debug("facebook-jssdk already exists");
      this._refresh();
      return;
    }

    const js = document.createElement("script");
    js.id = "facebook-jssdk";
    js.src = "https://connect.facebook.net/en_EN/sdk.js#xfbml=1&version=v3.2";
    js.onload = () => this._refresh();

    document.body.appendChild(js);
  }

  public componentDidUpdate() {
    this._refresh();
  }

  public render() {
    const props = this.props;

    return (
      <Container {...getContainerProps(props)}>
        {props.url ? (
          <>
            {props.embedType === "fb-post" && (
              <div
                className="fb-post"
                data-href={props.url}
                data-include-parent={props.includeParent}
                data-show-text="true"
              />
            )}
            {props.embedType === "fb-comment-embed" && (
              <div
                className="fb-comments"
                data-href={props.url}
                data-colorscheme={props.colorScheme}
                data-numposts={props.numberOfPosts}
                data-order-by={props.orderBy}
                data-width="100%"
              />
            )}
          </>
        ) : (
          <p>
            Follow the instructions to:{" "}
            <a href="https://developers.facebook.com/docs/plugins/embedded-posts" target="_blank">
              Get Post URL
            </a>{" "}
            or{" "}
            <a href="https://developers.facebook.com/docs/plugins/embedded-comments" target="_blank">
              Get Comment URL
            </a>
          </p>
        )}
      </Container>
    );
  }

  private _refresh = () => {
    const fb: any = window["FB"];
    fb && fb.XFBML.parse();
  };
}
